export default function TrustSection() {
  const trustItems = [
    {
      icon: 'ri-award-line',
      title: '5 Yıllık Deneyim',
      desc: '2021\'den bu yana 6+ sektörde dijital pazarlama ve reklam hizmeti veriyor, her yıl portföyümüzü ve uzmanlık alanlarımızı genişletiyoruz.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Ölçülebilir Sonuçlar',
      desc: 'Tüm kampanyalarımızı şeffaf KPI\'larla yönetiyor, müşterilerimize gerçek zamanlı dashboard erişimi sunuyoruz. Aylık detaylı performans raporları hazırlıyoruz.',
    },
    {
      icon: 'ri-team-line',
      title: 'Uzman Kadro',
      desc: '10+ kişilik ekibimiz; stratejist, kreatif direktör, medya planlamacı, yazılım geliştirici ve içerik üreticilerinden oluşan multidisipliner bir yapıya sahiptir.',
    },
    {
      icon: 'ri-building-4-line',
      title: 'Kurumsal Referanslar',
      desc: 'E Ofis, Ethos, Akyapı gibi sektör liderleriyle çalıştık. Endüstriyel, e-ticaret, finans ve sağlık sektörlerinde kanıtlanmış başarı hikayelerimiz var.',
    },
    {
      icon: 'ri-global-line',
      title: 'Çok Kanallı Uzmanlık',
      desc: 'Google Ads, Meta Ads, LinkedIn Ads, TikTok Ads ve programatik reklamcılık dahil tüm dijital reklam kanallarında sertifikalı uzman kadromuzla hizmet veriyoruz.',
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      title: 'Veri Odaklı Yaklaşım',
      desc: 'Her kararı veriyle alıyoruz. A/B testleri, ısı haritası analizi, kullanıcı davranışı izleme ve dönüşüm hunisi optimizasyonuyla sürekli iyileştirme sağlıyoruz.',
    },
  ];

  return (
    <section id="trust" className="section-padding bg-background-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10 md:mb-14">
          <p className="text-primary-500 font-bold text-sm tracking-widest uppercase mb-2">
            NEDEN BİZ?
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter">
            GÜVEN & KANIT
          </h2>
          <p className="text-sm md:text-base text-foreground-400 mt-3 font-medium max-w-xl speakable-summary">
            Dijital pazarlama ajansı seçerken referanslar, uzmanlık derinliği ve ölçülebilir sonuçlar en kritik karar kriterleridir. İşte BIFF Digital&apos;i sektörde farklı kılan güven sinyalleri.
          </p>
        </div>

        {/* Trust Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {trustItems.map((item, idx) => (
            <div key={idx} className="glass-card-hover rounded-2xl p-6 md:p-7 group">
              <div className="w-12 h-12 bg-background-200 rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary-500/10 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500`} />
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-50 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Listicle: Doğru Ajansı Seçme Kriterleri */}
        <div className="mt-12 md:mt-16 glass-card rounded-2xl p-6 md:p-8">
          <h3 className="text-xl md:text-2xl font-bold text-foreground-50 mb-6">
            Doğru Dijital Pazarlama Ajansını Seçmek İçin 5 Kriter
          </h3>
          <div className="space-y-5">
            {[
              {
                num: '01',
                title: 'Sektör Deneyimi ve Portföy Çeşitliliği',
                desc: 'Ajansın sizin sektörünüzde daha önce çalışıp çalışmadığını mutlaka sorgulayın. BIFF Digital endüstriyel, e-ticaret, finans ve sağlık olmak üzere 6+ sektörde kanıtlanmış vaka çalışmalarına sahiptir.',
              },
              {
                num: '02',
                title: 'Veri Odaklılık ve Raporlama Şeffaflığı',
                desc: 'Ajansın kampanyaları nasıl ölçümlediği ve raporladığı kritiktir. Biz tüm müşterilerimize gerçek zamanlı dashboard erişimi ve aylık detaylı performans raporları sunuyor, her KPI\'ı şeffafça paylaşıyoruz.',
              },
              {
                num: '03',
                title: 'Çok Kanallı Uzmanlık',
                desc: 'Tek bir kanala bağımlı ajanslardan kaçının. Google Ads, Meta Ads, LinkedIn, TikTok ve programatik reklamcılık dahil tüm dijital kanallarda yetkinlik şarttır.',
              },
              {
                num: '04',
                title: 'Stratejik Düşünme Kabiliyeti',
                desc: 'Ajans sadece reklam yayınlamamalı, marka stratejinize bütünsel bakabilmelidir. Marka konumlandırmasından içerik stratejisine, dönüşüm hunisi optimizasyonundan CRM entegrasyonuna kadar uçtan uca düşünebilmelidir.',
              },
              {
                num: '05',
                title: 'Referanslar ve Müşteri Yorumları',
                desc: 'Ajansın gerçek müşteri yorumlarını ve vaka çalışmalarını inceleyin. Üçüncü taraf platformlardaki değerlendirmeler, ajansın gerçek performansı hakkında en güvenilir sinyali verir.',
              },
            ].map((item, idx) => (
              <div key={idx} className="flex gap-4 md:gap-6">
                <div className="shrink-0 w-10 h-10 md:w-12 md:h-12 bg-primary-500 rounded-xl flex items-center justify-center">
                  <span className="text-foreground-50 font-black text-sm md:text-base">{item.num}</span>
                </div>
                <div>
                  <h4 className="text-base md:text-lg font-bold text-foreground-100 mb-1">
                    {item.title}
                  </h4>
                  <p className="text-sm text-foreground-400 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}